import Vue from 'vue'
import firebase from 'firebase'

import VueRouter from 'vue-router'
import Home from '@/views/Home.vue'
import Machines from '@/views/Machines.vue'
import Machine from '@/views/Machine.vue'
import About from '@/views/About.vue'
import Services from '@/views/Services.vue'
import SearchIndustries from '@/views/SearchIndustries.vue'
import Molding from '@/views/Molding.vue'
import Contact from '@/views/Contact.vue'
import Login from '@/views/Login.vue'
import Register from '@/views/Register.vue'
import Application from '@/views/Application.vue'
import Cart from '@/views/Cart.vue'
import Check from '@/views/Check.vue'

import MyAccount from '@/views/Account/MyAccount.vue'
import OrderList from '@/views/Account/OrderList.vue'
import Orders from '@/views/Account/Orders.vue'
import MachineList from '@/views/Machines/List.vue'
import ServiceList from '@/views/Services/List.vue'
import SlideList from '@/views/Slides/List.vue'
import SectionList from '@/views/Sections/List.vue'
import IndustryList from '@/views/Industry/List.vue'

import Error405 from '@/views/Errors/405.vue'

Vue.use(VueRouter)

const routes = [{
        path: '/',
        component: Home,
        meta: {
            title: "Vacuum Center"
        },
    },
    {
        path: '/verificando',
        component: Check,
        meta: {
            title: "Vacuum Center"
        },
    },
    {
        path: '/maquinas',
        component: Machines,
        meta: {
            title: "Vacuum Center - Máquinas - Soluções para Vacuum Forming"
        },
    },
    {
        path: '/aplicacoes',
        name: 'Applications',
        component: SearchIndustries,
        meta: {
            title: "Vacuum Center - Busca por aplicação"
        }
    },
    {
        path: '/aplicacoes/:cat',
        name: 'Applications',
        component: SearchIndustries,
        meta: {
            title: "Vacuum Center - Busca por aplicação"
        }
    },
    {
        path: '/maquina/:uri',
        component: Machine,
        meta: {
            title: "Vacuum Center - Máquina"
        },

    },
    {
        path: '/sobre',
        component: About,
        meta: {
            title: "Vacuum Center - Sobre"
        },


    },
    {
        path: '/moldes',
        component: Molding,
        meta: {
            title: "Vacuum Center - Moldes"
        },
    },
    {
        path: '/servicos',
        component: Services,
        meta: {
            title: "Vacuum Center - Nossos serviços"
        },
    },
    {
        path: '/contato',
        component: Contact,
        meta: {
            title: "Vacuum Center - Contato"
        },
    },
    {
        path: '/entrar',
        component: Login,
        meta: {
            title: "Vacuum Center - Entrar"
        },
    },
    {
        path: '/cadastrar',
        component: Register,
        meta: {
            title: "Vacuum Center - Cadastro"
        },

    },

    {
        path: '/app',
        component: Application,
        meta: {
            requiresAuth: true,
            title: "Vacuum Center - APP"
        },
        children: [{
                path: 'minha-conta',
                component: MyAccount
            },
            {
                path: 'maquinas',
                component: MachineList,
                meta: {
                    requiresAdmin: true
                }
            },
            {
                path: 'servicos',
                component: ServiceList,
                meta: {
                    requiresAdmin: true
                }
            },
            {
                path: 'slides',
                component: SlideList,
                meta: {
                    requiresAdmin: true
                }
            },
            {
                path: 'sessoes',
                component: SectionList,
                meta: {
                    requiresAdmin: true
                }
            },

            {
                path: 'pedidos',
                component: Orders
            },
            {
                path: 'meus-pedidos',
                component: OrderList
            },
            {
                path: 'industrias',
                component: IndustryList
            }
        ],
    },
    {
        path: '/pedido',
        component: Cart,
        meta: {
            requiresAuth: true,
            title: "Vacuum Center - Pedido"
        }
    },
    {
        path: '/erro/405',
        component: Error405
    }
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

router.beforeEach((to, from, next) => {
    const currentUser = firebase.auth().currentUser;
    const firestore = firebase.firestore()
    const TITLE = to.matched.some(record => record.meta.title);
    if (TITLE) {
        document.title = to.meta.title
    } else {
        document.title = 'Vacuum Center'
    }

    const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
    const requiresAdmin = to.matched.some(record => record.meta.requiresAdmin);
    if (requiresAdmin) {
        if (currentUser) {
            firestore.collection("companies").where("uid", "==", currentUser.uid).get()
                .then((snap) => {
                    let cont = 0;
                    console.log('snap')
                    console.log(snap)
                    snap.forEach((doc) => {
                        let data = doc.data()
                        console.log('data')
                        console.log(data)
                        if (data.type == 2) {
                            cont = 1
                            next()
                        } else {
                            next('/erro/405')
                        }
                    })
                    if (cont == 0)
                        next('/erro/405')


                })
        } else {
            next('/erro/405')
        }


    } else {
        if (requiresAuth && !currentUser) next('/entrar')
        else next()
    }
});

export default router